import { render, staticRenderFns } from "./ArchiveFolders.vue?vue&type=template&id=ad1c543e&"
import script from "./ArchiveFolders.vue?vue&type=script&lang=js&"
export * from "./ArchiveFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports